import { useQueryClient } from '@mint-lib/query-client';
import { Chat } from '@mint-sdk/api-ai-assistant';
import { useSetAtom } from 'jotai';
import { atomWithReset, useResetAtom } from 'jotai/utils';

export const relatedChatsAtom = atomWithReset<Chat.ChatItemType[]>([]);

const useMetadataChats = () => {
  const setRelatedChats = useSetAtom(relatedChatsAtom);
  const resetRelatedChats = useResetAtom(relatedChatsAtom);
  const queryClient = useQueryClient();

  const findRelatedChats = async ({
    entityId,
    entityType,
  }: {
    entityId: number;
    entityType: Chat.ChatDetailsQueryType['entityType'];
  }) => {
    const chatList = await queryClient.ensureQueryData(
      Chat.getChatList({ params: {} }),
    );

    const relatedChats = chatList.filter(
      (c) => c.entityId === String(entityId) && c.entityType === entityType,
    );

    if (relatedChats?.length) {
      setRelatedChats(relatedChats);
      return;
    }

    resetRelatedChats();
  };

  return { findRelatedChats };
};

export default useMetadataChats;
